module.exports = __webpack_public_path__ + "img/detail2.d3671b41.jpg";